export default __webpack_public_path__ + "static/media/goldingots.7ef79c3a.png";